import { BackgroundTask } from '../../controllers/types';

export const generateUIMessageForBTError = (bgTask: BackgroundTask) => `${bgTask.message} (${bgTask.job_id})`;
